(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4319],{

/***/ 49231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/[redirectUri]",
      function () {
        return __webpack_require__(88000);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 20090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  text-align: left;\n  font-size: 14px;\n  text-decoration: none;\n  color: var(--color-secondary);\n  margin-bottom: 32px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BackLink = function(_param) {
    var className = _param.className, text = _param.text, to = _param.to, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "text",
        "to"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to
    }, props), {
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(StyledA, {
            className: className,
            children: [
                "← ",
                text
            ]
        })
    }));
};
var StyledA = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-78d9d681-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (BackLink);


/***/ }),

/***/ 88000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(62691);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(18473);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60071);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81990);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96397);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2739);
/* harmony import */ var _components_core_BackLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20090);
/* harmony import */ var _components_core_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21523);
/* harmony import */ var _components_core_Flex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90656);
/* harmony import */ var _components_core_Heading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96169);
/* harmony import */ var _components_core_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43195);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _AuthUserContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92232);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9507);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96540);
/* harmony import */ var _components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41246);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40592);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30px;\n  height: 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #dd4b39;\n  color: var(--color-primary);\n  border: 1px solid var(--color-secondary);\n\n  svg {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #444444;\n  color: var(--color-primary);\n  border: 1px solid var(--color-secondary);\n  svg {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 100vh;\n  width: 500px;\n  margin: 0 auto;\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  aspect-ratio: 3 / 1;\n  width: 200px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  [theme-type='DARK'] & {\n    filter: invert(100%);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var LoginPage = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_AuthUserContext__WEBPACK_IMPORTED_MODULE_10__/* .useAuth */ .a)(), user = ref4.user, isLoading = ref4.isLoading, logout = ref4.logout, error = ref4.error, setError = ref4.setError;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(true), 2), isCheckingRedirect = ref5[0], setIsCheckingRedirect = ref5[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        _auth__WEBPACK_IMPORTED_MODULE_3__/* .getRedirectResults */ .S9().catch(function(err) {
            setError(err);
        }).finally(function() {
            setIsCheckingRedirect(false);
        });
    }, []);
    if (!isCheckingRedirect && !error && user && (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.redirectUri)) {
        router.push(decodeURIComponent(router.query.redirectUri));
    }
    var differentCredentialsError = function() {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(error, firebase_app__WEBPACK_IMPORTED_MODULE_12__/* .FirebaseError */ .ZR)) {
            var firebaseError = error;
            if (firebaseError.code === "auth/account-exists-with-different-credential") {
                return true;
            }
        }
        return false;
    }();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(FlexWrapper, {
            direction: "column",
            alignItems: "center",
            gap: "16px",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(LogoWrapper, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(LogoImage, {
                        layout: "fill",
                        alt: "Logo",
                        src: "/soc_logo.png"
                    })
                }),
                differentCredentialsError && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    align: "center",
                    weight: "bold",
                    children: "Pok\xfasil/a si sa prihl\xe1siť s emailom, s ktor\xfdm si sa už v minulosti prihl\xe1sil/a cez in\xfa službu. Ak si sa teraz pok\xfasil/a prihl\xe1siť cez GitHub, tak sa pros\xedm prihl\xe1s cez Google. Naopak ak si sa teraz pok\xfasil/a prihl\xe1siť cez Google, tak sa pros\xedm prihl\xe1s cez Github."
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_core_Heading__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    variant: "h4",
                    align: "center",
                    withAccentUnderline: true,
                    normalWeight: true,
                    children: "Prihl\xe1senie"
                }),
                isLoading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_Loading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
                !isLoading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .Fragment */ .HY, {
                    children: [
                        !user && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(GoogleButton, {
                                    iconBefore: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_18__/* .FaGoogle */ .ldW, {}),
                                    onClick: function() {
                                        return _auth__WEBPACK_IMPORTED_MODULE_3__/* .loginWithGoogle */ .Cb();
                                    },
                                    children: "Prihl\xe1siť cez Google"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(GithubButton, {
                                    iconBefore: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_18__/* .FaGithub */ .hJX, {}),
                                    onClick: function() {
                                        return _auth__WEBPACK_IMPORTED_MODULE_3__/* .loginWithGithub */ .JE();
                                    },
                                    children: "Prihl\xe1siť cez GitHub"
                                })
                            ]
                        }),
                        user && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                variant: "outline",
                                color: "primary",
                                onClick: logout,
                                children: "Logout"
                            })
                        }),
                        ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.returnTo) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_core_BackLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            to: decodeURIComponent(router.query.returnTo),
                            text: "Sp\xe4ť"
                        }),
                        !((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.returnTo) && ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.redirectUri) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_core_BackLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            to: decodeURIComponent(router.query.redirectUri),
                            text: "Sp\xe4ť"
                        })
                    ]
                })
            ]
        })
    });
};
var iconStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)(_templateObject());
var GoogleButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(_components_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e9bb512d-0"
})(_templateObject1(), iconStyle);
var GithubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(_components_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e9bb512d-1"
})(_templateObject2(), iconStyle);
var FlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e9bb512d-2"
})(_templateObject3(), _theme_device__WEBPACK_IMPORTED_MODULE_14__/* .device.S */ .U.S);
var LogoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e9bb512d-3"
})(_templateObject4());
var LogoImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_2___default())).withConfig({
    componentId: "sc-e9bb512d-4"
})(_templateObject5());
/* harmony default export */ __webpack_exports__["default"] = (LoginPage);


/***/ }),

/***/ 62691:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49231); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);